import script from "./clue-block.vue?vue&type=script&setup=true&lang=js"
export * from "./clue-block.vue?vue&type=script&setup=true&lang=js"

import "./clue-block.vue?vue&type=style&index=0&id=0459cb11&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0459cb11"]])

export default __exports__